import { __decorate, __extends } from "tslib";
import { inject, observer } from 'mobx-react';
import React from 'react';
import { deleteHygiene } from '../api/hygienes';
import { customConfirm } from '../utils/utils';
import { Button } from './Button';
import S from './HygieneItem.styl';
var HygieneItem = /** @class */ (function (_super) {
    __extends(HygieneItem, _super);
    function HygieneItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            loading: false,
        };
        _this.deleteItem = function () {
            var i18n = _this.props.store.i18n;
            var hygiene = _this.props.hygiene;
            if (hygiene) {
                customConfirm(i18n.hygienesDeleteSummary, _this.props.store, function (success) {
                    if (success) {
                        _this.setState({ loading: true });
                        var request = {
                            id: hygiene.id,
                        };
                        deleteHygiene(request).then(function () {
                            _this.setState({ loading: false });
                            _this.isUpdated();
                        }).catch(function (error) {
                            _this.setState({ loading: false });
                            alert(error);
                        });
                    }
                });
            }
        };
        _this.isUpdated = function () {
            if (_this.props.isUpdated) {
                _this.props.isUpdated();
            }
        };
        _this.isEditClicked = function () {
            if (_this.props.isEditClicked) {
                _this.props.isEditClicked(_this.props.hygiene);
            }
        };
        return _this;
    }
    HygieneItem.prototype.componentDidMount = function () {
        // Did Mount
    };
    HygieneItem.prototype.render = function () {
        var props = this.props;
        var hygiene = props.hygiene;
        var i18n = props.store.i18n;
        var loading = this.state.loading;
        return (React.createElement("div", { className: S.modelItem }, hygiene ?
            React.createElement(React.Fragment, null,
                React.createElement("div", { className: S.tableCell }, hygiene.title),
                React.createElement("div", { className: S.tableCell }, hygiene.subtitle),
                React.createElement("div", { className: S.tableCell },
                    React.createElement("div", { className: S.colorBlock, style: { backgroundColor: hygiene.color } })),
                React.createElement("div", { className: S.action },
                    React.createElement(Button, { className: S.updateButton, type: "button", onClick: this.isEditClicked }, i18n.actionUpdate),
                    React.createElement(Button, { className: S.deleteButton, type: "button", onClick: this.deleteItem }, i18n.actionDelete)))
            :
                React.createElement(React.Fragment, null)));
    };
    HygieneItem = __decorate([
        inject('store'),
        observer
    ], HygieneItem);
    return HygieneItem;
}(React.Component));
export { HygieneItem };
